import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CoinflipDeprecatedService } from '../coinflip.service';
import { GameIconComponent } from '@core/components/game-icon/game-icon.component';
import { ModalService } from '@features/modals/services/modal.service';
import { FairnessButtonComponent } from '../../../core/components/fairness-button/fairness-button.component';
import { CostComponent } from '../../../core/components/cost/cost.component';

@Component({
  selector: 'app-coinflip-info-bar',
  templateUrl: './coinflip-info-bar.component.html',
  styleUrls: ['./coinflip-info-bar.component.scss'],
  imports: [GameIconComponent, FairnessButtonComponent, CostComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoinflipInfoBarComponent {
  constructor(
    private modalService: ModalService,
    public deprecatedCoinflipService: CoinflipDeprecatedService
  ) {}

  openCreateGame() {
    this.modalService.openModal('CoinflipDepositModal');
  }
}
